export const PARAMETER_TYPES = {
  INTEGER: 'integer',
  STRING: 'string',
  BOOL: 'bool'
}
